/**
 * file : Footer.jsx
 * 설명 : 하단 바
 */

import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-light py-5">
      <div className="container px-4 px-lg-5">
        <div className="row">
          <div className="small text-center text-muted">
            <div className="footer__txt">
              <p className="txt detail_span">
                <span><Link to={'/SitePrivacy'} className="TextDecoration">개인정보처리방침</Link></span>
                <span><Link to={'/EmailRefuse'} className="TextDecoration line">이메일무단수집거부</Link></span>
              </p>
            </div>
            <div className="small text-center text-muted">
              <p className="txt">
                <span>E-mail :lhscj2466@gmail.com</span>
              </p>
            </div>
            <p className="small text-center text-muted">
              Copyright© 2023 HS Solutons. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
